import { render, staticRenderFns } from "./ReviewAgreementText.vue?vue&type=template&id=229c4d61&scoped=true"
import script from "./ReviewAgreementText.vue?vue&type=script&lang=js"
export * from "./ReviewAgreementText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c4d61",
  null
  
)

export default component.exports